import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'burger-menu',
  template: `
    <button  mat-button (click)="onBurgerClicked()" class="button-launcher">
    <div class="burger-menu" [class.active]="active">
      <div class="burger-container">
        <div class="burger-inner"></div>
      </div>
    </div>
    </button>
  `,
  styleUrls: [ 'burger-menu.component.scss' ]
})
export class BurgerMenuComponent implements OnInit {
  @Output() opened = new EventEmitter<any>();
  @Input() active = false;
  ngOnInit() {
    //this.active = this.init || false;
  }

  onBurgerClicked() {
    this.opened.emit();
  }
}
